/** Page surface for GA dimensions (RFRSH-4427). */
export type CallerIdPageTypeGA = 'phone_report' | 'fraud_report';

/** CTA placement for GA dimensions. */
export type CallerIdPlacementGA = 'sticky' | 'inline';

/**
 * Unit / copy variant keys for analytics (RFRSH-4427).
 * Sticky bar rotates block_spam, fraud_risk, auto_identify; inline uses fraud_scores.
 */
export type CallerIdUnitName =
  | 'block_spam'
  | 'fraud_risk'
  | 'auto_identify'
  | 'fraud_scores';

export const CALLER_ID_PRODUCT_GA = 'beenverified' as const;

/** localStorage: set when user taps "Notify me" so CTAs stay dismissed (RFRSH-4427). */
export const CALLER_ID_NOTIFY_STORAGE_KEY = 'rfrsh-4427-smart-caller-notify';

/** localStorage: user chose "Not interested" on the coming-soon modal (RFRSH-4427). */
export const CALLER_ID_NOT_INTERESTED_STORAGE_KEY =
  'rfrsh-4427-smart-caller-not-interested';

/** localStorage: user dismissed the bottom sticky bar only (RFRSH-4427). */
export const CALLER_ID_STICKY_DISMISSED_STORAGE_KEY =
  'rfrsh-4427-smart-caller-sticky-dismissed';

/** GrowthBook feature flag key (RFRSH-4427). */
export const CALLER_ID_GB_FLAG_KEY = 'rfrsh-4427' as const;

export const CALLER_ID_COPY: Record<
  CallerIdUnitName,
  { body: string; cta: string }
> = {
  block_spam: {
    body: 'Block spam before you answer. Enable Smart Caller ID to protect your phone.',
    cta: 'Turn On',
  },
  fraud_risk: {
    body: 'See fraud risk before you pick up. Get Smart Caller ID',
    cta: 'Enable',
  },
  auto_identify: {
    body: 'Automatically identify every caller. Turn on Smart Caller ID',
    cta: 'Turn On',
  },
  fraud_scores: {
    body: 'See fraud scores before you answer. Get real-time fraud scores and spam alerts for incoming calls',
    cta: 'Enable Caller Protection',
  },
};

export const CALLER_ID_STICKY_UNITS: readonly CallerIdUnitName[] = [
  'block_spam',
  'fraud_risk',
  'auto_identify',
];
